import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { DropdownModule } from 'primeng/dropdown';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages';
import { TableModule } from 'primeng/table';
import { CalendarModule } from 'primeng/calendar';
import { FileUploadModule } from 'primeng/fileupload';
import { CheckboxModule } from 'primeng/checkbox';

import { BulletinFormComponent } from './bulletin-form.component';


@NgModule({
    declarations: [BulletinFormComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        RouterModule,
        DropdownModule,
        AutoCompleteModule,
        InputTextModule,
        ButtonModule,
        MessageModule,
        MessagesModule,
        TableModule,
        CalendarModule,
        FileUploadModule,
        CheckboxModule
    ]
})
export class BulletinFormModule {

}